/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const SlackNew = defineMessages({
  titleOne: {
    id: 'Slack.SlackNew.titleOne',
    defaultMessage: 'Your customers are on Slack'
  },
  titleTwo: {
    id: 'Slack.SlackNew.titleTwo',
    defaultMessage: 'Your assistant can be too'
  },
  subtitle: {
    id: 'Slack.SlackNew.subtitle',
    defaultMessage:
      'Through Slack, your assistant is ready to join the collaboration hub that brings the right people, information, and tools together to get work done. <link>Learn more</link>'
  },
  instructions: {
    id: 'Slack.SlackNew.instructions',
    defaultMessage: 'What you’ll need'
  },
  instructionsDescription: {
    id: 'Slack.SlackNew.instructionsDescription',
    defaultMessage:
      "Select Create to get all the details, but here's what to expect:"
  },
  instructionsItem: {
    id: 'Slack.SlackNew.instructionsItem',
    defaultMessage:
      'Plan, design, and build your very own Slack App or pick a Slack App you plan to use.'
  },
  startBuildingSlackApps: {
    id: 'Slack.SlackNew.startBuildingSlackApps',
    defaultMessage: '<link>Start building Slack apps</link>'
  }
});

export const SlackQuickSetup = defineMessages({
  title: {
    id: 'Slack.SlackQuickSetup.title',
    defaultMessage: 'Set up Slack'
  },
  slackBot: {
    id: 'Slack.SlackQuickSetup.slackBot',
    defaultMessage: 'Slack bot'
  },
  connectSlack: {
    id: 'Slack.SlackQuickSetup.connectSlack',
    defaultMessage: 'Connect Slack'
  },
  configureSlack: {
    id: 'Slack.SlackQuickSetup.configureSlack',
    defaultMessage: 'Configure Slack'
  },
  connectAssistant: {
    id: 'Slack.SlackQuickSetup.connectAssistant',
    defaultMessage: 'Connect assistant'
  }
});

export const IntroStepMessages = defineMessages({
  instructions: {
    id: 'Slack.IntroStepMessages.instructions',
    defaultMessage: 'Steps to setting up Slack'
  }
});

export const SlackBotStepMessages = defineMessages({
  title: {
    id: 'Slack.SlackBotStepMessages.title',
    defaultMessage: 'Set up your Slack bot'
  },
  subtitleOne: {
    id: 'Slack.SlackBotStepMessages.subtitleOne',
    defaultMessage:
      '<link>Create a Slack app</link> if you don’t have one already. '
  },
  subtitleTwo: {
    id: 'Slack.SlackBotStepMessages.subtitleTwo',
    defaultMessage:
      'If you already have an app, go to the <link>Your Apps</link> page on the Slack website. Click the app you want to use.'
  }
});
